import { useSearchParams } from 'react-router';

/** What a detail page shows as a deleted, read-only preview (GH #331). */
export type DeletedPreviewEntity = 'asset' | 'inspection' | 'damage' | 'workPackage';

/**
 * URL flag of a deleted-item preview: `?deleted=damage`. It names the entity because a deleted damage
 * sits under a live asset and inspection, which must still load normally.
 */
export const DELETED_PREVIEW_PARAM = 'deleted';

/** Link to a deleted item's detail page, opened as a read-only preview. */
export const deletedPreviewHref = (path: string, entity: DeletedPreviewEntity) =>
	`${path}?${DELETED_PREVIEW_PARAM}=${entity}`;

/** Whether the current page previews a deleted `entity`. */
export function useDeletedPreview(entity: DeletedPreviewEntity): boolean {
	const [searchParams] = useSearchParams();
	return searchParams.get(DELETED_PREVIEW_PARAM) === entity;
}
